import styled from 'styled-components';

export const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0;
`;

export const Layout = styled.div`
  display: flex;
  gap: var(--spacing-base);
`;

export const SearchBoxWrapper = styled.div`
  & .ais-SearchBox-form {
    position: relative;
    display: flex;
    align-items: center;
    height: 45.6px;
    border: 1px solid var(--grey-400);
    border-radius: var(--radius-base);
    background: var(--white);
    overflow: hidden;
    color: rgb(38, 38, 39);
    line-height: 16px;

    &:focus-within {
      border: 1px solid var(--brand-600);
      box-shadow: var(--shadow-focus);
    }
  }

  & .ais-SearchBox-submit {
    order: -1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 47px;
    height: 44px;
    margin: 0;
    padding: 0 8px 0 11px;
    border: none;
    background: transparent;
    cursor: pointer;

    & svg {
      width: 20px;
      height: 20px;
      fill: none;
      stroke: var(--grey-400);
    }
  }

  & .ais-SearchBox-input {
    flex: 1;
    height: 44px;
    padding: 0;
    border: none;
    outline: none;
    font-size: 16px;
    font-family: 'Inter', sans-serif;
    color: rgb(38, 38, 39);
    background: transparent;

    &::placeholder {
      color: rgba(128, 126, 163, 0.6);
      opacity: 1;
    }

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
      appearance: none;
      display: none;
    }
  }

  & .ais-SearchBox-reset {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12.83px;
    border: none;
    background: transparent;
    cursor: pointer;
    color: rgba(128, 126, 163, 0.6);

    & svg {
      width: 12px;
      height: 12px;
    }

    &[hidden] {
      display: none;
    }
  }

  & .ais-SearchBox-loadingIndicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    padding: 0;
    margin: 2px 0;

    & svg {
      width: 16px;
      height: 16px;
      color: var(--brand-800);
    }

    &[hidden] {
      display: none;
    }
  }
`;
